(function () {

	// Find all the packaging checkboxes.
	var $packagingCheckboxes = $('input[type="checkbox"][data-packaging-for]');

	$packagingCheckboxes.on('change', function () {

		// Store references to the checkbox and the corresponding instructions panel.
		var $packagingCheckbox = $(this),
			$instructionsPanel = $('#instructions-' + $packagingCheckbox.data('packaging-for'));

		// If the packaging checkbox is checked, show the instructions panel.
		$instructionsPanel.toggleClass('d-none', !$packagingCheckbox.is(':checked'));

	});

})();